"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nextToken = exports.isPaginated = void 0;
const PAGINATION_HEADER = 'next-page';
const isPaginated = (response) => {
    return response.headers[PAGINATION_HEADER] !== undefined;
};
exports.isPaginated = isPaginated;
const nextToken = (response) => {
    return response.headers[PAGINATION_HEADER] === "null" ? "" : response.headers[PAGINATION_HEADER];
};
exports.nextToken = nextToken;
